export default __webpack_public_path__ + "static/media/hd.aa15c3fc.jpg";